module.exports = __webpack_public_path__ + "static/media/epsAvatar.7657817e.png";